// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// Action Imports
import { Tooltip } from "@revvsales/components";
import {
  DynamicFieldActions,
  QuotationActions,
  EditorActions,
} from "../../actions";

import {
  updateDocumentClickedComponentID,
  updateHoveredDocumentSectionId,
} from "../../actions/DocumentActions/index";

// Utils import
import { getSelectedText } from "../../utils/draftUtils";

// Destructuring
const { addDynamicField } = DynamicFieldActions;
const { updateToolPaneData } = QuotationActions;
const { nukeEditorState } = EditorActions;

function DynamicFieldButton(props) {
  function _onClick(event) {
    event.preventDefault();

    // Get User Seletected Text
    const {
      editorState,
      highlightSelection,
      removeHighlightSelection,
      clickedActiveComponentId,
    } = props;
    const selectedText = getSelectedText(editorState);
    highlightSelection();
    props.updateToolPaneData(true, "dynamic-fields", "TEMPLATE");
    props.addDynamicField(
      props.component,
      props.editorState,
      selectedText,
      removeHighlightSelection,
    );
    props.updateHoveredDocumentSectionId(null);
    props.nukeEditorState();
    if (clickedActiveComponentId) {
      props.updateDocumentClickedComponentID(null, true, null);
    }
  }

  return (
    <div
      className="draft-edit-items"
      id="toolbar-dynamic-field-button"
      key="toolbar-dynamic-field-button">
      <Tooltip
        placement="bottom"
        align={{
          offset: [3, 0],
        }}
        overlay="Convert text into form fields. Form fields are placeholders for data that you can fill in a form, when creating documents.">
        <div className="draftJsToolbar__buttonWrapper__1Dmqh">
          <button
            type="button"
            className="dynamicfield-button"
            data-test="dynamicfieldbutton-button"
            id="template-add-dynamic-field-btn"
            onMouseDown={_onClick}>
            <i>
              <FontAwesomeIcon icon={["fas", "brackets"]} />
            </i>
            Add Form Field
          </button>
        </div>
      </Tooltip>
    </div>
  );
}

DynamicFieldButton.propTypes = {
  // Props
  component: PropTypes.shape({}).isRequired,
  editorState: PropTypes.shape({}).isRequired,

  // Actions
  addDynamicField: PropTypes.func.isRequired,
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => {
  const { clickedActiveComponentId } = state.DocumentStore;
  return { clickedActiveComponentId };
};

const mapDispatchToProps = {
  nukeEditorState,
  addDynamicField,
  updateToolPaneData,
  updateDocumentClickedComponentID,
  updateHoveredDocumentSectionId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DynamicFieldButton);



// WEBPACK FOOTER //
// ./src/components/RevvToolBar/DynamicFieldButton.js